import { useEffect, useState } from "react";
import inventoryGif from "../../assets/inventory-management.gif";
import hero1 from "../../assets/hero1.jpg";
import hero2 from "../../assets/hero2.jpg";
import hero3 from "../../assets/hero3.jpg";
import Footer from "../Footer";
import Navbar from "../Navbar";
import "./android-app.css";
import { Helmet } from "react-helmet-async";

export default function ITStaffAugmentationServices() {
  const heroImages = [hero1, hero2, hero3];
  const totalSlides = heroImages.length; // ✅ FIX
  const [currentSlide, setCurrentSlide] = useState(0);

  /* ================= HERO SLIDESHOW ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(interval);
  }, [totalSlides]); // ✅ FIXED

  /* ================= TIMELINE PROGRESS ================= */
  useEffect(() => {
    const timeline = document.getElementById("brand-timeline");
    if (!timeline) return;

    const line = timeline.querySelector(".timeline-line");
    const items = timeline.querySelectorAll(".timeline-item");

    const onScroll = () => {
      const rect = timeline.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const progress = Math.min(
        Math.max((windowHeight - rect.top) / (rect.height + windowHeight), 0),
        1
      );

      const lineHeight = progress * rect.height;
      line.style.height = `${lineHeight}px`;

      items.forEach((item) => {
        const itemOffset = item.offsetTop;
        if (lineHeight >= itemOffset + 20) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ================= FADE-UP ================= */
  useEffect(() => {
    const elements = document.querySelectorAll(".animate");
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (entry) =>
            entry.isIntersecting &&
            entry.target.classList.add("visible")
        ),
      { threshold: 0.2 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
    <Helmet>
  <title>
    IT Staff Augmentation Services – Hire Dedicated Developers | Manovate Technologies
  </title>

  <meta
    name="description"
    content="Manovate Technologies provides IT staff augmentation services to help businesses hire dedicated software developers, mobile app developers, full stack engineers, DevOps specialists, and IT professionals on flexible engagement models."
  />

  <link
    rel="canonical"
    href="https://www.manovate.co.in/itservices/it-staff-augmentation-services"
  />
</Helmet>

    <Navbar />
      {/* ================= HERO ================= */}
      <section className="hero-modern">
        <div className="hero-slideshow">
          {heroImages.map((img, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? "active" : ""}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
        </div>

        <div className="hero-overlay"></div>

        <div className="service-hero-content animate">
          <h1>IT Staff Augmentation Services</h1>
          <p>
            Flexible IT staff augmentation services to help businesses quickly
            hire skilled software developers, mobile app developers, full stack
            engineers, and DevOps professionals.
          </p>

          <a href="#services" className="btn-primary">
            Get Started
          </a>
        </div>
      </section>

      {/* ================= OVERVIEW ================= */}
      <section className="section-white">
        <div className="service-container">
          <h2>Overview</h2>

          <p className="section-intro">
            Our IT staff augmentation model enables companies to scale
            development teams with vetted engineers across web, mobile,
            cloud, and enterprise software projects.
          </p>

          <div className="grid">
            <div className="card animate">
              <h3>Software & Application Developers</h3>
              <p>
                Experienced frontend, backend, and full stack developers
                for enterprise-grade software solutions.
              </p>
            </div>

            <div className="card animate">
              <h3>Mobile App Development Teams</h3>
              <p>
                Android, iOS, React Native, and cross-platform mobile
                app development experts.
              </p>
            </div>

            <div className="card animate">
              <h3>Specialized Engineering Talent</h3>
              <p>
                DevOps, cloud engineers, AI specialists, QA automation,
                and database experts.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="section-light">
        <div className="service-container">
          <h2>How Our IT Staff Augmentation Works</h2>

          <div className="timeline" id="brand-timeline">
            <div className="timeline-line"></div>

            <div className="timeline-item">
              <span className="timeline-label">Planning</span>
              <h3>Skill & Team Assessment</h3>
              <p>
                We analyze project scope, tech stack, and skill requirements.
              </p>
            </div>

            <div className="timeline-item">
              <span className="timeline-label">Onboarding</span>
              <h3>Hire Dedicated Developers</h3>
              <p>
                Rapid onboarding of vetted developers who integrate with
                your in-house teams.
              </p>
            </div>

            <div className="timeline-item">
              <span className="timeline-label">Delivery</span>
              <h3>Ongoing Collaboration & Scale</h3>
              <p>
                Agile delivery, scalable teams, and long-term project
                success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHY US ================= */}
      <section className="section-white" id="services">
        <div className="service-container">
          <h2>Why Choose Us</h2>

          <div className="why-grid">
            <div className="why-box animate">
              <h3>Top Engineering Talent</h3>
              <p>
                Access experienced developers and IT specialists from
                India’s leading talent pool.
              </p>
            </div>

            <div className="why-box animate">
              <h3>Flexible Engagement Models</h3>
              <p>
                Scale teams up or down with cost-effective staff
                augmentation.
              </p>
            </div>

            <div className="why-box animate">
              <h3>Faster Delivery</h3>
              <p>
                Accelerate development while maintaining quality and
                budget efficiency.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CONTACT ================= */}
      <section className="contact-section" id="contact">
        <div className="service-container contact-grid">
          <div className="contact-left">
            <h2>Contact Manovate Technologies</h2>
            <p>
              Hire dedicated developers and scale your development
              teams quickly with our IT staff augmentation services.
            </p>

            <form
              className="service-contact-form"
              onSubmit={(e) => {
                e.preventDefault();
                alert("Thank you! Our team will contact you shortly.");
              }}
            >
              <input type="text" placeholder="Your name*" required />
              <input type="email" placeholder="Your email*" required />
              <textarea
                rows="4"
                placeholder="Tell us about your staffing needs..."
                required
              ></textarea>

              <button type="submit" className="submit-btn">
                Submit Project
              </button>
            </form>
          </div>

          <div className="contact-right gif-container">
            <img
              src={inventoryGif}
              alt="IT Staff Augmentation"
              className="contact-gif"
            />
          </div>
        </div>
      </section>
      <p className="service-backlink">
  Explore our complete range of{" "}
  <a href="/itservices">IT Services & Software Engineering Solutions</a>.
</p>
<br />
<br />
      <Footer />
    </>
  );
}
